import { isDefined } from "@clipboard-health/util-ts";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useIsWorkplaceReviewUXUpdateEnabled } from "../../../PostShiftReview/hooks/useIsWorkplaceReviewUXUpdateEnabled";
import {
  LEAVE_REVIEW_ENTRYPOINT,
  type LeaveReviewEntrypoint,
} from "../../../PostShiftReview/types";
import { useGetQuestions } from "./api/useGetQuestions";
import { useGetWorkplaceWorkerShifts } from "./api/useGetWorkplaceWorkerShifts";

interface UseCanLeaveReviewParams {
  workplaceId: string;
  workplaceType?: string;
  source: LeaveReviewEntrypoint;
}

export function useCanLeaveReview({ workplaceId, workplaceType, source }: UseCanLeaveReviewParams) {
  const { userId: workerId } = useDefinedWorker();

  const { data: shifts = [] } = useGetWorkplaceWorkerShifts({
    workerId,
    workplaceId,
  });

  const { isEnabled: isWorkplaceReviewUXUpdateEnabled } = useIsWorkplaceReviewUXUpdateEnabled();

  const { data: questions = { data: [] } } = useGetQuestions(
    {
      workplaceType: workplaceType ?? "",
      workplaceId,
    },
    { enabled: isDefined(workplaceType) }
  );

  const hasQuestions = questions.data.length > 0;
  const hasShifts = shifts.length > 0;
  const canSkipShiftRequirement =
    isWorkplaceReviewUXUpdateEnabled && source === LEAVE_REVIEW_ENTRYPOINT.WORKPLACE_PROFILE;

  return {
    canLeaveReview: canSkipShiftRequirement ? hasQuestions : hasShifts && hasQuestions,
  };
}
